import React, { useCallback, useEffect, useState } from 'react';
import { api, formatCOP } from '../services/api';
import { pedidoClienteLabel } from '../utils/textEncoding';

function hoyLocalISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function fechaCompletado(p) {
  const raw = p.preparado_at || p.updated_at;
  if (!raw) return '';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return String(raw).slice(0, 10);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function fmtHora(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
}

export default function OficinaSidebarHistorial({ pin, selectedId, onSelect, refreshKey }) {
  const [fecha, setFecha] = useState(hoyLocalISO);
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setPedidos([]);
    setError('');
    try {
      const res = await api.getHistorial({ fecha });
      const items = (Array.isArray(res.data) ? res.data : []).filter(
        (p) => p.estado === 'entregado' && fechaCompletado(p) === fecha
      );
      setPedidos(items);
    } catch (err) {
      setPedidos([]);
      setError(err.message || 'No se pudo cargar el historial');
    } finally {
      setLoading(false);
    }
  }, [pin, fecha]);

  useEffect(() => {
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, [load, refreshKey]);

  return (
    <div className="sidebar-historial">
      <div className="sidebar-historial-head">
        <h3>Historial</h3>
        <span className="sidebar-historial-count">{pedidos.length}</span>
      </div>
      <label className="sidebar-fecha">
        <span>Día</span>
        <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
      </label>
      <p className="sidebar-historial-sub">Historial</p>

      {error ? <p className="sidebar-historial-empty sidebar-historial-error">{error}</p> : null}
      {loading ? (
        <p className="sidebar-historial-empty">Cargando...</p>
      ) : !error && pedidos.length === 0 ? (
        <p className="sidebar-historial-empty">Sin pedidos</p>
      ) : null}
      {!loading && pedidos.length > 0 ? (
        <ul className="sidebar-historial-list">
          {pedidos.map((p) => (
            <li key={p.id}>
              <button
                type="button"
                className={`sidebar-hist-row ${selectedId === p.id ? 'selected' : ''}`}
                onClick={() => onSelect(p.id)}
              >
                <strong>{p.numero}</strong>
                <span>
                  {pedidoClienteLabel(p)}
                  {p.es_sede || p.padre_codigo ? ' · Sucursal' : ''}
                </span>
                <em>
                  {fmtHora(p.preparado_at || p.updated_at || p.created_at)} · {formatCOP(p.subtotal)}
                </em>
                {p.preparado_por_nombre ? (
                  <small>Sep. {p.preparado_por_nombre}</small>
                ) : null}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
